export default function (context, val) {
    let form = context.state;
    form.AccountId = val.AccountId;
    form.SubAccountId = val.SubAccountId;
    form.ContragentId = val.ContragentId;
    form.ContragentName = val.ContragentName;
    form.CurrencyId = val.CurrencyId;
    form.PaymentAccountId = val.PaymentAccountId;
    form.WithTurns = val.WithTurns;
    form.WithDocumens = val.WithDocumens;

    let dFrom = new Date(), dTo = new Date();
    switch (val.dateStep) {
        case 1:
            dFrom.setDate(dFrom.getDate() - val.dateInt);
            break;
        case 2:
            dFrom.setDate(dFrom.getDate() - val.dateInt * 7);
            break;
        case 3:
            dFrom.setMonth(dFrom.getMonth() - val.dateInt);
            if (val.dateRound) {
                dFrom.setDate(1);
            }
            break;
    }

    form.dates = [
        '' + (dFrom.getDate() > 9 ? '' : '0') + dFrom.getDate() + '.' + (dFrom.getMonth() > 8 ? '' : '0') + (dFrom.getMonth() + 1) + '.' + dFrom.getFullYear(),
        '' + (dTo.getDate() > 9 ? '' : '0') + dTo.getDate() + '.' + (dTo.getMonth() > 8 ? '' : '0') + (dTo.getMonth() + 1) + '.' + dTo.getFullYear()
    ];
    if (val.searchClick) {
        context.dispatch('finances/osv/list/search', null, {root: true});
    }
}